var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', [_c('div', {
    staticClass: "dropdownsContainer"
  }, [_c('b-form-select', {
    staticClass: "primaryBorderDropdown",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "options": _vm.filteredTeams
    },
    model: {
      value: _vm.selectedTeam,
      callback: function ($$v) {
        _vm.selectedTeam = $$v;
      },
      expression: "selectedTeam"
    }
  }), _c('b-form-select', {
    staticClass: "primaryBorderDropdown",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "options": _vm.filteredYears
    },
    model: {
      value: _vm.selectedYear,
      callback: function ($$v) {
        _vm.selectedYear = $$v;
      },
      expression: "selectedYear"
    }
  })], 1)]), _c('div', {
    staticClass: "userInfo-withCalender-container mt-5"
  }, [_c('div', {
    staticClass: "dayBar"
  }, [_c('div', {
    staticClass: "dayBar-inner"
  }, _vm._l(_vm.calendarData.days, function (day) {
    return _c('div', {
      key: day.id,
      class: `dayName currentDay ${day.initial == 'Su' || day.initial == 'Sa' ? 'offDay' : ''}`
    }, [_vm._v(" " + _vm._s(day.initial) + " ")]);
  }), 0)]), _vm._l(_vm.calendarData.items, function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "dayBar withDate"
    }, [item.type === 'employee' ? _c('div', {
      staticClass: "userInfo-container"
    }, [_c('div', {
      staticClass: "userInfo-container-inner"
    }, [_c('div', {
      staticClass: "userInfo-img"
    }, [_c('img', {
      attrs: {
        "src": item.employee.thumb_url,
        "alt": "logo"
      }
    })]), _c('div', {
      staticClass: "userInfo"
    }, [_c('div', {
      staticClass: "userInfo-heading"
    }, [_vm._v(_vm._s(item.employee.full_name))])])])]) : _vm._e(), item.type === 'employee' ? _c('div', {
      staticClass: "dayBar-inner"
    }, _vm._l(_vm.calendarData.days, function (day) {
      return _c('div', {
        key: day.id,
        staticClass: "dayName",
        class: {
          selectedDate: item.employee.events.hasOwnProperty(day.id),
          offDay: day.weekend
        }
      }, [_c('div', {
        directives: [{
          name: "b-popover",
          rawName: "v-b-popover.hover.focus.top",
          value: {
            title: _vm.getProperty(item, 'employee.events[day.id][0].policy_name'),
            content: _vm.getProperty(item, 'employee.events[day.id][0].details'),
            disabled: !item.employee.events.hasOwnProperty(day.id)
          },
          expression: "{\n              title: getProperty(item,'employee.events[day.id][0].policy_name'),\n              content: getProperty(item,'employee.events[day.id][0].details'),\n              disabled: !item.employee.events.hasOwnProperty(day.id)\n            }",
          modifiers: {
            "hover": true,
            "focus": true,
            "top": true
          }
        }],
        staticClass: "dateItself",
        class: _vm._f("filterEventsClasses")(item.employee.events[day.id]),
        style: `background: ${_vm.getProperty(item, 'employee.events[day.id][0].policy_color')};`
      }, [_vm._v(" " + _vm._s(day.day_of_month) + " ")])]);
    }), 0) : _vm._e()]);
  })], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }